export default function validEmail(str) {
  return str.length <= 254 && /^\S{1,64}@\S+\.\S+$/.test(str);
}
